import options from './help-icon.component';

export default {
    selector: 'dtHelpIcon',
    options
};



// WEBPACK FOOTER //
// ./app/common/help-icon/index.js